/*=========================================================================================
  File Name: moduleCategoryActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";
import {
	createVisitPointPayload,
	createVisitPointFromShipmentsPayload,
	processVisitPointRecords,
	commitVisitPoints,
	createVisitPointPaginatedPayload,
} from "@/store/payloadHelper.js";

export default {
	save({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.post("/visit_point", payload)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	fetchVisitPoint({commit}) {
		return new Promise((resolve, reject) => {
			Api.get("/visit_point")
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	findVisitPointPaginated({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = createVisitPointPaginatedPayload(data);
			Api.post("/visit_point/filter", payload)
				.then((res) => {
					const processedRecords = processVisitPointRecords(res.data.records);
					commit("SET_VISIT_POINTS", processedRecords);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	findById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.get(`/visit_point/${id}`)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	update({commit}, payload) {
		return new Promise((resolve, reject) => {
			Api.put(`/visit_point/${payload.id}`, payload.items)
				.then((response) => {
					commit("UPDATE_VISIT_POINT", response.data);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	deleteById({commit}, id) {
		return new Promise((resolve, reject) => {
			Api.delete(`/visit_point/${id}`)
				.then((response) => {
					commit("REMOVE_VISIT_POINT", id);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	findVisitPointsAssigned({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000000,
				fields: [
					"id",
					"identification",
					"address",
					"city",
					"cx",
					"cy",
					"capacities",
					"time_window_id",
					"repeat_frequency_id",
				],
				id: data.id || [],
				identification: data.identification || [],
				address: data.address || [],
				city: data.city || [],
				order_by: data.order_by || ["id"],
				sort: data.sort || "asc",
				skills_id: data.skills_id || [],
				capacities: data.capacities || [],
				time_windows_id: data.time_windows_id || [],
				repeat_frequency_id: data.repeat_frequency_id || [],
			};
			Api.post("/visit_point/filter", payload)
				.then((res) => {
					res.data.records.forEach((element) => {
						element.demand = 0;
						element.typeService = "PICKUP";
						element.isEditDemand = false;
						element.isEditTypeService = false;
						element.isPickup = false;
						element.isDelivery = false;
					});
					commit("SET_ASSIGNED_VISIT_POINT", res.data.records);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	currentVisitPointSelected({commit}, visitPoint) {
		return new Promise((resolve, reject) => {
			commit("SELECTED_VISIT_POINT", visitPoint);
			resolve(visitPoint);
		});
	},
	findVisitPointPaginatedFromShipments({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = createVisitPointFromShipmentsPayload(data);
			Api.post("/visit_point/filter", payload)
				.then((res) => {
					const processedRecords = processVisitPointRecords(res.data.records);
					commitVisitPoints(commit, processedRecords, data.shippingType);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
	findVisitPointAdditionalFields({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = createVisitPointPayload(data);
			Api.post("/visit_point/filter", payload)
				.then((res) => resolve(res.data))
				.catch((err) => reject(err));
		});
	},
	findVisitPointPaginatedDatarutas({commit}, data) {
		return new Promise((resolve, reject) => {
			const payload = {
				page: data.page || 1,
				quantity: data.quantity || 1000000,
				id: data.id || [],
				status_id: data.status_id || [],
				category_id: [],
				name: data.name || "",
				identification: data.identification || "",
				address: data.address || "",
				city: data.city || "",
				phone: "",
				order_by: data.order_by || "name",
				sort: data.sort || "ASC",
				resource_id: data.resource_id || null,
				additional_info: data.additional_info || null,
				typology_id: data.typology_id || [],
				exact_values: data.exact_values || false,
				fields: [
					"id",
					"name",
					"identification",
					"address",
					"city",
					"department",
					"country",
					"phone",
					"cx",
					"cy",
					"additional_info",
					"status_id",
					"status_name",
					"typology_id",
					"typology_name",
					"category_id",
					"resource_id",
					"total_resource",
					"visit_point_user_id",
				],
				on_demand: data.on_demand || null,
			};
			Api.post("/datarutas/visit/point/filter", payload)
				.then((res) => {
					res.data.records.forEach((element) => {
						element.isPickup = false;
						element.isDelivery = false;
					});
					commit("SET_VISIT_POINTS_DATARUTAS", res.data.records);
					resolve(res.data);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},
};
